import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {OttopilotEventContainer} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainer";
import type {EventContainerTemplate} from "~/domainModels/workspaceModules/eventContainersModule";
import type {CapabilityUdoColumnResolver} from "~/utilities/capabilityUdoTemplateColumns";
import {getEventContainerOrganizationalUnitId} from "~/utilities/ottopilotSemanticColumns";
import {isGeographyAdditionalColumnType, resolveGeographyAdditionalColumnValue} from "~/utilities/geographyValueResolver";

/** Display business location without treating geography master IDs as OU IDs. */
export function formatEventContainerLocation(
    getAdditionalColumns: CapabilityUdoColumnResolver,
    row: Pick<OttopilotEventContainer, "additionalColumnValues">,
    template: EventContainerTemplate,
    formatOu: (id: Uuid) => string,
): string {
    if (template.configuration.organizationalUnitColumnConfig !== null) {
        return formatOu(getEventContainerOrganizationalUnitId(row, template));
    }
    const column = getEventContainerGeographyLocationColumn(getAdditionalColumns, template);
    const value = row.additionalColumnValues[column.id];
    const label = resolveGeographyAdditionalColumnValue(column.type, value);
    if (typeof value === "string" && (label === null || label === "-")) {return value;}
    return label ?? "-";
}

export function getEventContainerGeographyLocationColumn(getAdditionalColumns: CapabilityUdoColumnResolver, template: EventContainerTemplate) {
    const id = template.configuration.uacmGeographyColumnId;
    const columns = getAdditionalColumns(template).filter(column => column.id === id);
    const column = columns[0];
    if (columns.length !== 1 || column === undefined || !isGeographyAdditionalColumnType(column.type)) {
        throw new Error("The Event Container geography location is not configured correctly");
    }
    return column;
}
